"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M19.6802 9.1319 11.9998 2 4.3193 9.1319l1.361 1.4655 6.3195-5.8681 6.3195 5.8681 1.3609-1.4656zM4.3198 14.8682 12.0002 22l7.6805-7.1318-1.3609-1.4656-6.3196 5.8681-6.3195-5.8681-1.361 1.4656z"
  })];
};

exports.default = _default;